import { MirrorFeatures, useBoardContext } from "@rastreabilidadebrasil/tageditor";
import { Button } from "@mui/material";
import { SymmetryVertical } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

const MirrorHorizontal = (props: { mirrorFeature: MirrorFeatures | undefined }) => {
  const { board } = useBoardContext();
  const { t } = useTranslation("editor");
  return (
    <Button
      className="btn"
      startIcon={<SymmetryVertical size={16} />}
      onClick={() => props.mirrorFeature?.mirror("horizontal")}
      disabled={!board?.activeObjects.length}
    >
      {t("Espelhamento horizontal")}
    </Button>
  );
};

export default MirrorHorizontal;
